module.exports = __webpack_public_path__ + "cfp/CFP-template.docx";


//////////////////
// WEBPACK FOOTER
// ./src/cfp/CFP-template.docx
// module id = 1007
// module chunks = 0